import { SkaldValue } from '@skaldaura/devkit'
import PagesReader from 'components/pagesReader/pagesReader'
import { useState } from 'react'
import Popup from 'reactjs-popup'
import { Colors } from 'styles/colors'
import './catalogue.scss'

export interface IPopulatedCatalogue {
   pages?: SkaldValue[]
   qr?: SkaldValue[]
}

interface IProps {
   label: string
   color: string
   catalogue: IPopulatedCatalogue
   lang: string
}

export default function Catalogue({ color, label, catalogue, lang }: IProps) {
   const [open, setOpen] = useState(false)

   const closeModal = () => setOpen(false)
   const openModal = () => setOpen(true)

   return (
      <div className='flex'>
         <Popup
            trigger={
               <img
                  src={catalogue.pages ? catalogue.pages[0].value : ''}
                  alt=''
                  style={{ width: '150px', border: '1px solid ' + Colors.black }}
               />
            }
            modal
            closeOnDocumentClick
            open={open}
            onClose={closeModal}
            onOpen={openModal}
         >
            {
               <PagesReader
                  close={closeModal}
                  pages={catalogue.pages ? catalogue.pages.map((page) => page.value) : []}
               />
            }
         </Popup>
         <div className='catalogue-finger' style={{ backgroundColor: color }}>
            <img src={`${process.env.PUBLIC_URL}/img/finger.png`} alt='' />
         </div>
         {catalogue.qr && catalogue.qr.length > 0 && (
            <div id='bloc-catalogue'>
               <img src={catalogue.qr[0].value} alt='' style={{ width: '125px' }} />
               <br />
               {/* Le substring est là pour retirer le "en matière de résine" dans la section "solutions durables". Prévoir quelque chose de plus flexible à l'avenir ? */}
               <p style={{ color: color }}>
                  {lang === 'en' ? 'Download the catalogue' : 'Téléchargez le catalogue'}
               </p>
            </div>
         )}
      </div>
   )
}
